import { render } from "./DiscussionQuestList.vue?vue&type=template&id=98a18e40"
import script from "./DiscussionQuestList.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./DiscussionQuestList.vue?vue&type=script&charset=utf-8&lang=js"

import "./DiscussionQuestList.vue?vue&type=style&index=0&id=98a18e40&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__